const extractSpacingValue = (utilityClasses, prefix) => {
    const match = utilityClasses.match(new RegExp(`(?:^|\\s)${prefix}-(\\d+)(?:\\s|$)`));
    if (!match) {
        return undefined;
    }
    const spacing = Number.parseInt(match[1], 10);
    return Number.isNaN(spacing) ? undefined : spacing;
};
const buildPaddingInlineStyle = (utilityClasses) => {
    const paddingTop = extractSpacingValue(utilityClasses, 'pt');
    const paddingBottom = extractSpacingValue(utilityClasses, 'pb');
    const inlineStyles = [];
    if (paddingTop !== undefined) {
        inlineStyles.push(`padding-top:${paddingTop}px`);
    }
    if (paddingBottom !== undefined) {
        inlineStyles.push(`padding-bottom:${paddingBottom}px`);
    }
    return inlineStyles.length > 0 ? inlineStyles.join(';') : undefined;
};

export { buildPaddingInlineStyle };
